export default "__VITE_ASSET__fd57a25c__"